import React, { FC } from 'react';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
import { renderReact } from '../../fragmentHelper/renderReactCustom';

import { PagePropsType } from '../../types';
import { Didomi as DidomiContainer } from '@rakutenfrance/didomi';

export const serverCanCache = true;

interface DidomiProps {
  noticeId?: string;
}

const Didomi: FC<DidomiProps & PagePropsType> = ({ initialApolloState, initialReduxState, noticeId }) => {
  return (
    <ReduxApolloFragmentWrapperChildren
      initialApolloState={initialApolloState}
      initialReduxState={initialReduxState}
      reducers={{}}
    >
      <DidomiContainer didomiNoticeId={noticeId} />
    </ReduxApolloFragmentWrapperChildren>
  );
};

export const renderFunction = renderReact('Didomi', Didomi);
export const serverCanCashe = true;
